<template>
  <div class="animated fadeIn mt-5" v-if="dataLoaded">
    <form
      enctype="multipart/form-data"
      v-on:submit="validateBeforeSubmit($event, false)"
    >
      <div class="row">
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>DSR</strong>
            </div>
            <modal-select
              label="Distribuidor"
              modal="dealers-new-modal"
              name="dealer_id"
              v-bind:readonly="false"
              v-bind:item-id="item.dealer_id"
              v-bind:item-name="item.dealer.data.name"
              v-on:select-item="selectDealer"
              :state="validateState('dealer_id')"
            ></modal-select>
            <modal-select modal="dsr-modal" name="leader_id" :readonly="item.id>0" :item-id="item.leader_id" :item-name="item.leader?item.leader.data.name:''" v-on:select-item="selectDsr"  :state="validateState('leader_id')" placeholder="Leader" label="Leader" ></modal-select>

            <b-form-fieldset label="Nome">
              <b-form-input
                type="text"
                name="name"
                v-model="item.name"
                placeholder="Nome"
                v-validate="'required'"
                :state="validateState('name')"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first("name") }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-row>
              <b-form-fieldset class="col-sm-4" label="NIF">
                <b-form-input
                  type="text"
                  name="nif"
                  v-model="item.nif"
                  placeholder="NIF"
                  :state="validateState('nif')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("nif") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset label="Código" class="col-sm-4">
                <b-form-input
                  type="text"
                  name="code"
                  v-model="item.code"
                  placeholder="Código"
                  :disabled="item.state === 3"
                  :state="validateState('code')"
                />
                <b-form-invalid-feedback>
                  {{ errors.first("code") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>
            <b-form-row>
              <b-form-fieldset label="Tipo" class="col-sm-4">
                <b-form-select
                  :options="dsrTypes"
                  name="dsr_type"
                  v-model="item.dsr_type"
                  placeholder="Tipo"
                  v-validate="'required'"
                  :state="validateState('dsr_type')"
                ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first("dsr_type") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset label="Estado" class="col-sm-4">
                <b-form-select
                  :options="stateOptions"
                  name="state"
                  v-model="item.state"
                  placeholder="Estado"
                  v-validate="'required'"
                  :state="validateState('state')"
                ></b-form-select>

                <b-form-invalid-feedback>
                  {{ errors.first("code") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>

            <b-form-row>
              <b-form-fieldset class="col-sm-6" label="Nome próprio">
                <b-form-input
                  type="text"
                  name="first_name"
                  v-model="item.first_name"
                  placeholder="Nome próprio"
                  :state="validateState('first_name')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("first_name") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset class="col-sm-6" label="Apelido">
                <b-form-input
                  type="text"
                  name="last_name"
                  v-model="item.last_name"
                  placeholder="Apelido"
                  :state="validateState('last_name')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("last_name") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>

            <b-form-row>
              <b-form-fieldset class="col-sm-6" label="Email">
                <b-form-input
                  type="text"
                  name="email"
                  v-model="item.email"
                  placeholder="Email"
                  v-validate="'required'"
                  :state="validateState('email')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("email") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset class="col-sm-6" label="Telefone">
                <b-form-input
                  type="text"
                  name="phone"
                  v-model="item.phone"
                  placeholder="Telefone"
                  :state="validateState('phone')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("phone") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>
            <b-form-row>
              <b-form-fieldset class="col-sm-9" label="Morada">
                <b-form-input
                  type="text"
                  name="address"
                  v-model="item.address"
                  placeholder="Morada"
                  :state="validateState('address')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("address") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset class="col-sm-3" label="Nº de porta">
                <b-form-input
                  type="text"
                  name="address_door"
                  v-model="item.address_door"
                  placeholder="Nº de porta"
                  :state="validateState('address_door')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("address_door") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>
            <b-form-row>
              <b-form-fieldset class="col-sm-3" label="Código postal">
                <b-form-input
                  type="text"
                  name="zip_code"
                  v-model="item.zip_code"
                  placeholder="Código postal"
                  :state="validateState('zip_code')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("zip_code") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset class="col-sm-6" label="Localidade">
                <b-form-input
                  type="text"
                  name="locality"
                  v-model="item.locality"
                  placeholder="Localidade"
                  :state="validateState('locality')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first("locality") }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-form-row>

            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link
                    :to="{ name: 'dsr-new.index' }"
                    size="sm"
                    variant="danger"
                    ><i class="fa fa-ban"></i> Cancelar</router-link
                  >
                </div>
                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary"
                    ><i class="fa fa-save"></i> Gravar</b-button
                  >
                  <b-button
                    type="button"
                    v-on:click="validateBeforeSubmit($event, true)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-save"></i> Gravar e fechar</b-button
                  >
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>Códigos Vendedor</strong>
            </div>
            <div
              class="form-row"
              v-for="(codigo, index) in item.dealerdsr.data"
            >
              <b-form-group class="col-md-3">
                <input
                  type="text"
                  v-model="codigo.code"
                  class="form-control"
                  placeholder="Código UFS"
                />
              </b-form-group>
              <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
                <input
                  type="text"
                  v-model="codigo.date_start"
                  v-mask="'####-##-##'"
                  class="form-control"
                  placeholder="Data de ínicio"
                />
              </b-form-group>
              <b-form-group description="(AAAA-mm-dd)" class="col-md-3">
                <input
                  type="text"
                  v-model="codigo.date_end"
                  v-mask="'####-##-##'"
                  class="form-control"
                  placeholder="Data de fim"
                />
              </b-form-group>
              <b-form-group
                class="col-md-3"
                v-if="item.dealerdsr.data.length > 1"
              >
                <b-button variant="danger" v-on:click="removeDealerUFS(index)"
                  ><i class="fa fa-times"></i
                ></b-button>
              </b-form-group>
            </div>
            <button
              type="button"
              v-on:click="addDealerUFS()"
              class="btn btn-primary"
            >
              <i class="fa fa-plus"></i> Adicionar código
            </button>
          </b-card>
          <b-card>
            <div slot="header">
              <strong>Dados de acesso</strong>
            </div>
            <b-form-fieldset label="Username">
              <b-form-input
                type="text"
                name="username"
                v-model="item.inparuser.data.username"
                placeholder="Username"
                :state="validateState('username')"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first("username") }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Password">
              <b-form-input
                type="text"
                name="password"
                v-model="item.inparuser.data.password"
                placeholder="Password"
                :state="validateState('password')"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first("password") }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
          </b-card>

          <!-- CREATE mode: user selects leader -->
          <b-card v-if="!item.id && item.dsr_type == 1 && item.dealer_id">
            <div slot="header"><strong>Líder</strong></div>

            <b-form-group label="Líder">
              <b-form-select
                name="leader_id"
                v-model="item.leader_id"
                :options="leaderOptions"
                :disabled="!item.dealer_id || leaders.length === 0"
                placeholder="Selecione o líder"
                :state="validateState('leader_id')"
              ></b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first("leader_id") }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-row>
              <b-col md="8">
                <b-form-group description="(AAAA-mm-dd)">
                  <input
                    type="text"
                    v-model="item.leader_date_start"
                    v-mask="'####-##-##'"
                    class="form-control"
                    placeholder="Data de início"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-card>

          <!-- EDIT mode: show leader name read-only -->
          <b-card v-else-if="item.id && item.dsr_type == 1 && item.leader_id">
            <div slot="header"><strong>Líder</strong></div>

            <b-form-group label="Líder">
              <b-form-input
                type="text"
                :value="item.leader.data.name"
                readonly
              ></b-form-input>
              <div class="mb-3">
                <label class="d-block font-weight-bold mb-1">Zona</label>

                <div
                  class="d-flex align-items-center justify-content-between border rounded p-1 bg-light"
                >
                  <span>{{ item.leader.data.zone_name }}</span>

                  <b-badge variant="secondary" class="ml-2" secondary>
                    {{ item.leader.data.zone }}
                  </b-badge>
                </div>
              </div>
            </b-form-group>
          </b-card>

          <!-- Info message only for create mode when no dealer or not dsr_type 1 -->
          <b-alert
            v-else-if="!item.id && (!item.dealer_id || item.dsr_type != 1)"
            show
            variant="info"
            class="mt-3"
          >
            Para associar um líder, deverá selecionar um
            <strong>Distribuidor</strong> e deve ser do tipo
            <strong>Vendedor</strong>.
          </b-alert>
        </b-col>
      </div>
    </form>
  </div>
</template>

<script>
import lists from "@/components/States.js";
export default {
  name: "DealersEdit",
  props: ["id"],
  data() {
    return {
      dataLoaded: false,
      item: {
        name: "",
        code: "",
        dealerdsr: {
          data: [],
        },
        dealer: {
          data: [],
        },
        inparuser: {
          data: {},
        },
        zones: {
          data: [],
        },
        leader_id: null,
        leader: {
          data: {},
        },
        leader_date_start: "",
        leader_date_end: "",
      },
      leaders: [],
      stateOptions: lists.states,
      dsrTypes: lists.dsrTypes,
    };
  },
  computed: {
    leaderOptions() {
      return this.leaders.map((leader) => ({
        value: leader.id,
        text: leader.name || leader.username || `Líder #${leader.id}`,
      }));
    },
  },
  watch: {
    "item.dealer_id"(newVal) {
      this.tryFetchLeaders();
    },
    "item.dsr_type"(newVal) {
      this.tryFetchLeaders();
    },
    "item.state"(newVal) {
    if (newVal === 3) {
      this.item.code = "-1";
    } else if (newVal === 1 && this.item.code === "-1") {
      this.item.code = "";
    }
  }
  },
  methods: {
    tryFetchLeaders() {
      if (this.item.dealer_id && this.item.dsr_type == 1) {
        this.fetchLeadersByDealer(this.item.dealer_id);
      } else {
        this.leaders = [];
        this.item.leader_id = null;
      }
    },
    selectLeader(e) {
      if (e.item) {
        this.item.leader_id = e.item.id;
        this.item.leader.data = e.item;
      } else {
        this.item.leader_id = null;
        this.item.leader.data = {};
      }
    },
    selectDealer(e) {
      if (e.item) {
        this.item.dealer_id = e.item.id;
        this.item.dealer.data = e.item;
        console.log("Dealer selected:", e.item.id);
        this.fetchLeadersByDealer(this.item.dealer_id);
      } else {
        this.item.dealer_id = null;
        this.item.dealer.data = { id: null, name: null };
        this.leaders = [];
      }
    },
    fetchAssociatedLeader(dsrId) {
      if (!dsrId) return;

      console.log("Fetching associated leader for DSR:", dsrId);

      this.axios
        .get(`teamsnew/${dsrId}/leader`)
        .then((response) => {
          console.log("Associated leader response:", response.data);
          this.item.leader_id = response.data.leader_id;
          this.$set(this.item, "leader", {
            data: {
              name: response.data.leader,
              zone: response.data.leader_zone,
              zone_name: response.data.leader_zone_name,
            },
          });
        })
        .catch((error) => {
          console.error("Error fetching associated leader:", error);
          this.item.leader_id = null;
          this.$set(this.item, "leader", { data: {} });
        });
    },
    fetchLeadersByDealer(dealerId) {
      console.log("Fetching leaders for dealer:", dealerId);

      this.axios
        .get(`dealers/${dealerId}/leaders`)
        .then((response) => {
          console.log("Leaders response:", response.data);
          this.leaders = response.data || [];
        })
        .catch((error) => {
          console.error("Error fetching leaders:", error);
          this.leaders = [];
        });
    },
    addDealerUFS() {
      this.item.dealerdsr.data.push({});
    },
    removeDealerUFS(i) {
      this.item.dealerdsr.data.splice(i, 1);
    },
    addZone() {
      this.item.zones.data.push({});
    },
    removeZone(i) {
      this.item.zones.data.splice(i, 1);
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault();
      console.log("check validation");
      this.$validator.validateAll().then((result) => {
        console.log("validation results:", result);
        if (result) {
          console.log("all fields ok. submit");
          this.submit(evt, close);
          return;
        }
        this.$bvToast.toast(`Tem campos inválidos`, {
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit(e, close) {
  e.preventDefault();

  // 🔒 ENFORCE: inactivo (0) must have code = -1
  if (this.item.state === 3) {
    this.item.code = "-1";
  }

  const payload = { data: this.item };

  const request = this.item.id
    ? this.axios.put(`dsrnew/${this.item.id}`, payload)
    : this.axios.post("dsrnew", payload);

  request
    .then((response) => {
      this.item = response.data.data;

      // Re-fetch leader so the card shows again
      if (this.item.id && this.item.dsr_type == 1) {
        this.fetchAssociatedLeader(this.item.id);
      }

      console.log("AFTER SAVE response:", response.data);

      this.$bvToast.toast(`item gravado com sucesso`, {
        autoHideDelay: 5000,
        variant: "success",
        solid: true,
      });

      if (close || !this.item.id) {
        this.$router.push({
          name: this.item.id ? "dsr-new.index" : "dsr-new.edit",
          params: { id: this.item.id },
        });
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0][0];
        this.$bvToast.toast(firstError, {
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
      } else {
        this.$bvToast.toast(`Não foi possivel gravar`, {
          autoHideDelay: 5000,
          variant: "danger",
          solid: true,
        });
      }
    });
},
  },
  // created() {
  //   var id = this.$route.params.id;
  //   if (typeof id !== "undefined") {
  //     this.axios
  //       .get("dsrnew" + "/" + id)
  //       .then((response) => {
  //         this.item = response.data.data;
  //         // dealerdsr: {
  //         //   data: []
  //         // },
  //         // dealer: {
  //         //   data: []
  //         // },
  //         // inparuser: {
  //         //   data: {}
  //         // },
  //         // zones: {
  //         //   data: []
  //         // }
  //         if (typeof this.item.dealerdsr === "undefined") {
  //           this.item.dealerdsr = { data: [] };
  //         }
  //         if (typeof this.item.dealer === "undefined") {
  //           this.item.dealer = { data: [] };
  //         }
  //         if (typeof this.item.inparuser === "undefined") {
  //           this.item.inparuser = { data: {} };
  //         }
  //         if (this.item.dealer_id) {
  //           this.fetchLeadersByDealer(this.item.dealer_id);
  //         }
  //         if (typeof this.item.zones === "undefined") {
  //           this.item.zones = { data: [] };
  //         }
  //         this.dataLoaded = true;
  //       })
  //       .catch((response) => {
  //         this.$bvToast.toast(`Este item não existe`, {
  //           autoHideDelay: 5000,
  //           variant: "danger",
  //           solid: true,
  //         });
  //         this.$router.push({
  //           name: "dsr-new.index",
  //         });
  //       });
  //   } else {
  //     this.dataLoaded = true;
  //   }
  // },
  created() {
    const id = this.$route.params.id;

    if (id) {
      this.axios
        .get(`dsrnew/${id}`)
        .then((response) => {
          this.item = response.data.data;

          // Ensure nested data structure exists
          if (!this.item.dealerdsr) this.item.dealerdsr = { data: [] };
          if (!this.item.dealer) this.item.dealer = { data: [] };
          if (!this.item.inparuser) this.item.inparuser = { data: {} };
          if (!this.item.zones) this.item.zones = { data: [] };

          // If it has a dealer, prefetch available leaders
          if (this.item.dealer_id) {
            this.fetchLeadersByDealer(this.item.dealer_id);
          }

          // Fetch the leader associated with this DSR (for edit mode)
          if (this.item.id && this.item.dsr_type == 1) {
            this.fetchAssociatedLeader(this.item.id);
          }

          this.dataLoaded = true;
        })
        .catch(() => {
          this.$bvToast.toast(`Este item não existe`, {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.$router.push({ name: "dsr-new.index" });
        });
    } else {
      this.dataLoaded = true;
    }
  },
};
</script>
